<article class="collection-card">
  <a [routerLink]="['/', 'collections', collection?.handle]">
    <img
      class="product-image product-image-ratio"
      [src]="collection?.image?.url || placeholderImageUrl"
      [alt]="collection?.image?.altText || collection?.title"
    />
  </a>

  <span class="d-block fw-normal mt-2">{{ collection?.title }}</span>
</article>
